import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import {createOrg, getOrgs} from '../services/orgService';
import ErrorAlert from "../components/ErrorAlert";
import FormDialog from "../patterns/FormDialog";
import TextInput from "../patterns/form/TextInput";

export default class CreateOrganisation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orgId: null,
            redirectUrl: null,
            name: '',
            busy: false,
            createOrgError: null,
        }
    }

    async componentDidMount() {
        if (!this.props.authentication) {
            console.warn('Not logged in, redirecting')
            this.setState({redirectUrl: '/'});
            return;
        }
        if (this.props.authentication.organisation) {
            console.warn('user already has an org, redirecting to it')
            this.setState({redirectUrl: `/organisations/${this.props.authentication.organisation.id}`});
            return;
        }
    }

    cancelCreate = () => {
        this.props.history.goBack();
    }

    nameChanged = (event) => {
        this.setState({name: event.target.value});
    }

    create = async () => {
        this.setState({busy: true});
        try {
            const newOrgId = await createOrg(this.state.name);
            const orgs = await getOrgs();
            const org = orgs.find(o => (o.id === newOrgId));
            this.props.onOrgCreate(org);
            this.setState({redirectUrl: `/organisations/${newOrgId}`})
        } catch (e) {
            this.setState({createOrgError: `Problem creating organisation: ${e.toString()}`, busy: false});
        }
    }

    render() {
        if (this.state.redirectUrl) {
            return <Redirect to={this.state.redirectUrl}/>
        }

        const {name, busy, createOrgError} = this.state;

        return (
            <FormDialog
                open
                title="Create a new organisation"
                onCancel={this.cancelCreate}
                onSubmit={this.create}
                submitLabel="Create"
                submitDisabled={!name}
                busy={busy}
            >
                {(firstFieldRef) => (
                    <>
                        {createOrgError && <ErrorAlert message={createOrgError} delay={0}/>}
                        <TextInput
                            ref={firstFieldRef}
                            id="create-org-name"
                            label="Organisation name"
                            placeholder="Enter a name for the organisation"
                            value={name}
                            onChange={this.nameChanged}
                        />
                    </>
                )}
            </FormDialog>
        );
    }
}
